<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 13 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M9.33333 3.33333C9.33333 2.96514 9.63181 2.66667 10 2.66667C10.3682 2.66667 10.6667 2.96514 10.6667 3.33333V7.05729L11.5286 6.19531C11.789 5.93496 12.211 5.93496 12.4714 6.19531C12.7317 6.45566 12.7317 6.87767 12.4714 7.13802L10.4714 9.13802C10.211 9.39837 9.78899 9.39837 9.52865 9.13802L7.52865 7.13802C7.2683 6.87767 7.2683 6.45566 7.52865 6.19531C7.78899 5.93496 8.211 5.93496 8.47135 6.19531L9.33333 7.05729V3.33333ZM4.66667 6.66667C5.03486 6.66667 5.33333 6.96514 5.33333 7.33333C5.33333 7.70152 5.03486 8 4.66667 8H0.666667C0.298477 8 0 7.70152 0 7.33333C0 6.96514 0.298477 6.66667 0.666667 6.66667H4.66667ZM6.66667 3.33333C7.03486 3.33333 7.33333 3.63181 7.33333 4C7.33333 4.36819 7.03486 4.66667 6.66667 4.66667H0.666667C0.298477 4.66667 0 4.36819 0 4C0 3.63181 0.298477 3.33333 0.666667 3.33333H6.66667ZM8.66667 0C9.03486 0 9.33333 0.298477 9.33333 0.666667C9.33333 1.03486 9.03486 1.33333 8.66667 1.33333H0.666667C0.298477 1.33333 0 1.03486 0 0.666667C0 0.298477 0.298477 0 0.666667 0H8.66667Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'reorder-icon',
    props: {
        width: {
            type: [String, Number],
            default: 13,
        },
        height: {
            type: [String, Number],
            default: 10,
        },
        color: {
            type: String,
            default: 'text-[#AAB0BA]',
        },
    },
};
</script>


